module.exports = __webpack_public_path__ + "img/profess2.169b5faf.png";